import {handleActions} from 'redux-actions';

import {SIGN_OUT} from '/redux/action/auth.action';
import {
  GET_CLIENT_METRICS,
  GET_HOME_METRICS,
  GET_TEAMS_METRICS,
  SET_METRIC_META,
} from '/redux/action/metric.action';
import {withPayload} from '/util/reducer.util';

import authSignOut from './metric/auth/signOut';
import getClientMetrics from './metric/getClientMetrics';
import getHomeMetrics from './metric/getHomeMetrics';
import getTeamsMetrics from './metric/getTeamsMetrics';
import setMeta from './metric/setMeta';

const initialState = {
  allClients: {},
  allTeams: {},
  allPerformances: {},
  allEarnings: {},
  homeMetrics: {},
  metricMeta: {},
};

export default handleActions(
  {
    [GET_CLIENT_METRICS]: withPayload(getClientMetrics),
    [GET_TEAMS_METRICS]: withPayload(getTeamsMetrics),
    [GET_HOME_METRICS]: withPayload(getHomeMetrics),
    [SET_METRIC_META]: withPayload(setMeta),
    [SIGN_OUT]: withPayload(authSignOut),
  },
  initialState,
);
